if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.mobileFixedSubmitButton = this.querySelector('[data-mobile-fixed-submit]');
        this.allSubmitButtons = [this.submitButton, this.mobileFixedSubmitButton].filter(Boolean);
        this.spinners = this.querySelectorAll('.loading__spinner');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.lastClickedButton = null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        // Track which button was clicked
        this.allSubmitButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            this.lastClickedButton = btn;
          });
        });

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const buttonsToStyle = this.lastClickedButton
          ? [this.lastClickedButton]
          : this.allSubmitButtons;

        buttonsToStyle.forEach((btn) => {
          btn.setAttribute('aria-disabled', true);
          btn.classList.add('loading');

          btn.querySelectorAll('span:not(.sold-out-message)').forEach((span) => {
            span.classList.add('hidden');
          });
        });

        this.spinners.forEach(spinner => spinner.classList.remove('hidden'));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelectorAll('span:not(.sold-out-message)').forEach((span) => {
                  span.classList.add('hidden');
                });
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    
                    // Check bundle promotion after adding product via quick add
                    if (window.bundlePromotion) {
                      setTimeout(async () => {
                        try {
                          const cartResponse = await fetch(`${routes.cart_url}.js`);
                          const cartData = await cartResponse.json();
                          const cartItems = document.querySelector('cart-items');
                          if (cartItems) {
                            cartItems.checkBundlePromotion(cartData);
                          }
                        } catch (error) {
                          console.error('Bundle promotion: Error fetching cart data', error);
                        }
                      }, 100);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              
              // Check bundle promotion after adding product
              if (window.bundlePromotion) {
                setTimeout(async () => {
                  try {
                    const cartResponse = await fetch(`${routes.cart_url}.js`);
                    const cartData = await cartResponse.json();
                    const cartItems = document.querySelector('cart-items');
                    if (cartItems) {
                      cartItems.checkBundlePromotion(cartData);
                    }
                  } catch (error) {
                    console.error('Bundle promotion: Error fetching cart data', error);
                  }
                }, 100);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.allSubmitButtons.forEach((btn) => {
              btn.classList.remove('loading');
              if (!this.error) btn.removeAttribute('aria-disabled');

              btn.querySelectorAll('span:not(.sold-out-message)').forEach((span) => {
                span.classList.remove('hidden');
              });
            });

            this.spinners.forEach(spinner => spinner.classList.add('hidden'));

            if (this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            this.lastClickedButton = null;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
